module.exports = __webpack_public_path__ + "img/icon_map_37_off_111.1d38ad5a.png";